<div class="w-full h-full flex justify-center">

    <div class="w-full">

        <div class="w-full flex flex-col gap-8">
            <div class="w-full flex flex-row md:justify-end items-center gap-5">
                <!-- Title & Subtitle -->
                <div class="w-full flex flex-col gap-[5px]" [ngClass]="{'hidden': !breakpoint.md.value}">
                    <div class="flex items-center gap-1">
                        <p class="text-[22px] font-semibold" i18n>
                            Gebruikers
                        </p>
                    </div>
                    <p *ngIf="connection.role.value === 'admin'" class="text-[16px] text-app-global-text-secondary"
                        i18n>
                        Gebruikers in organisatie {{ organization.currentOrganization$.value?.name }}
                    </p>
                </div>

                <div class="flex flex-col-reverse justify-end xs:flex-row w-full gap-3 md:gap-5">
                    <!-- Search -->
                    <mat-form-field class="w-full md:max-w-60 search">
                        <input matInput i18n-placeholder placeholder="Zoeken..." [formControl]="searchControl">
                    </mat-form-field>

                    <!-- New user -->
                    <button mat-flat-button color="primary" class="shrink-0" routerLink="/settings/users/new">
                        <span *ngIf="breakpoint.lg.value && !breakpoint.xl.value" i18n>
                            Nieuw
                        </span>
                        <span *ngIf="!(breakpoint.lg.value && !breakpoint.xl.value)" i18n>
                            Nieuwe gebruiker
                        </span>
                    </button>
                </div>
            </div>


            <!-- Users table -->
            <app-table [settings]="userTableSettings" #table>
                <!-- Name -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef i18n> Naam </th>
                    <td mat-cell *matCellDef="let user">
                        <p>{{user.name}} </p>
                    </td>
                </ng-container>

                <!-- Email -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef i18n [ngClass]="{'hidden': !breakpoint.lg.value}"> E-mailadres
                    </th>
                    <td mat-cell *matCellDef="let user" [ngClass]="{'hidden': !breakpoint.lg.value}">
                        <p>{{user.email}}</p>
                    </td>
                </ng-container>

                <!-- Role -->
                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef i18n> Rol </th>
                    <td mat-cell *matCellDef="let user">
                        <p *ngIf="user.role === 'admin'" i18n>Admin</p>
                        <p *ngIf="user.role === 'manager'" i18n>Manager</p>
                        <p *ngIf="user.role === 'editor'" i18n>Bewerker</p>
                        <p *ngIf="user.role === 'chatter'" i18n>Chatter</p>
                    </td>
                </ng-container>

                <!-- Created at -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef i18n> Aangemaakt op </th>
                    <td mat-cell *matCellDef="let user" matTooltip="{{user.created_at | date: 'dd/MM/yyyy HH:mm'}}">
                        <p>{{user.created_at | date: 'dd/MM/yyyy'}} </p>
                    </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef i18n></th>
                    <td mat-cell *matCellDef="let user">
                        <div class="flex items-center justify-end w-full">
                            <!-- Edit -->
                            <button mat-button
                                *ngIf="!(userService.profile.role === 'manager' && user.role === 'admin')"
                                class="text-app-global-primary" i18n>
                                <mat-icon svgIcon="pencil"></mat-icon>
                                Bewerken
                            </button>
                        </div>
                    </td>
                </ng-container>
            </app-table>
        </div>
    </div>
</div>